module.exports = __webpack_public_path__ + "img/2W.2.1e131ea9.jpg";